import { InjectionToken } from '@angular/core';

export interface GrafanaCloudEmbedConfig {
  defaultTheme: 'light' | 'dark';
  defaultKioskMode: 'full' | 'tv' | null;
  defaultRefreshInterval: string | null;
  requestTimeoutMs: number;
}

export const GRAFANACLOUD_EMBED_CONFIG = new InjectionToken<GrafanaCloudEmbedConfig>('GrafanaCloudEmbedConfig');

/** Base URL for the GrafanaCloud iframe/embed content — Grafana Cloud's own domain, a different origin
 * than API_BASE_URL. The iframe points directly at Grafana Cloud (no reverse proxy) so the browser's
 * own Entra SSO session with it drives per-user access. */
export const GRAFANACLOUD_BASE_URL = new InjectionToken<string>('GrafanaCloudBaseUrl');

export interface EmbedUrlOptions {
  theme?: 'light' | 'dark';
  kioskMode?: 'full' | 'tv' | null;
  refreshInterval?: string | null;
  queryParams?: Record<string, string>;
}

export interface GrafanaDashboardSummary {
  uid: string;
  slug: string;
  title: string;
  embedPath: string;
  folderTitle?: string;
  folderUid?: string;
  description?: string;
  tags: string[];
}
